import { Link } from "@inertiajs/react"
import { Shield } from "lucide-react"

import { cn } from "@/lib/utils"

// The explainer + capacity meter above the tabs. "Collaborators see the document
// only" copy, a filled-dots meter (used / max), and a link across to Team for
// whole-workspace sharing. Purely presentational — the used/max/atCap numbers are
// server-derived (unique people, not grant rows — §6).
export default function CapacityStrip({ capacity }) {
  const used = capacity?.used ?? 0
  const max = capacity?.max ?? 3

  return (
    <div className="mb-[18px] flex items-center gap-[14px] rounded-[13px] border border-border bg-card px-[18px] py-[14px]">
      <div className="grid size-[38px] shrink-0 place-items-center rounded-[11px] border border-border bg-secondary">
        <Shield className="size-[19px] text-muted-foreground" strokeWidth={1.8} />
      </div>

      <div className="min-w-0 flex-1">
        <b className="text-[13px] font-bold text-foreground">Collaborators see the document only</b>
        <p className="mt-0.5 text-[12px] leading-[1.5] text-ink-3">
          People you add can <b className="font-semibold text-foreground">read and comment</b> on a
          project&apos;s manuscript while it&apos;s in review — they can&apos;t approve, pay, or change the
          order. Sharing a whole workspace instead? Use{" "}
          <Link href="/team" className="font-semibold text-foreground underline-offset-2 hover:underline">
            Team
          </Link>
          .
        </p>
      </div>

      <div className="flex shrink-0 flex-col items-end gap-1.5">
        <div className="text-[12px] font-semibold text-muted-foreground">
          <b className="font-display">{used}</b> of {max} people
        </div>
        <div className="flex gap-[5px]">
          {Array.from({ length: max }, (_, i) => (
            <span
              key={i}
              className={cn(
                "size-[9px] rounded-full border",
                i < used ? "border-foreground bg-foreground" : "border-line-2 bg-secondary"
              )}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
